import assets from '../../../constants/_assets'

const getAssetById = async ({ id }) => {
	return assets[id]
}

export default { getAssetById }
